<template>
  <div class="app-container">
    <el-row
      style="margin-top: 20px; margin-bottom: 10px"
      :gutter="10"
      class="mb8"
    >
      <el-col :span="5">
        <el-input
          clearable
          size="mini"
          v-model="param.keywords"
          placeholder="请输入关键字"
          @input="InputValue"
        ></el-input>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="GetSearchProblems"
          >搜索</el-button
        >
      </el-col>
    </el-row>

    <el-table :data="problemData" style="width: 100%">
      <el-table-column prop="create_time" label="提问日期" width="240">
      </el-table-column>
      <el-table-column prop="user_id" label="用户" width="50">
      </el-table-column>
      <el-table-column prop="feedback_type" label="类型" width="100">
      </el-table-column>
      <el-table-column prop="content" label="问题内容" width="400">
      </el-table-column>
      <el-table-column prop="reply_content" label="回复内容" width="400">
      </el-table-column>
      <el-table-column prop="reply_time" label="回复时间"> </el-table-column>
      <el-table-column
        prop="status"
        label="回复状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            class="button"
            v-if="problemData[scope.$index].status == 1"
          >
            已回复
          </el-button>

          <el-button
            type="text"
            size="mini"
            v-if="problemData[scope.$index].status == 0"
          >
            未回复
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="status">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleReply(scope.row)"
            v-if="problemData[scope.$index].status == 0"
            >回复</el-button
          >
          <el-button
            type="success"
            size="mini"
            @click="handleReply(scope.row)"
            v-if="problemData[scope.$index].status == 1"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :total="total"
      :page.sync="param.pageNum"
      :limit.sync="param.pageSize"
      @pagination="GetSearchProblem"
    />

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
      <el-form :model="from" ref="ruleForm" class="demo-ruleForm">
        <el-row>
          <el-col class="el-row1">
            <el-form-item label="问题内容">
              <el-input
                readonly
                v-model="from.content"
                placeholder="请输入问题内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="问题类型">
              <el-input
                readonly
                v-model="from.feedback_type"
                placeholder="请输入问题类型"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="问题时间">
              <el-input
                readonly
                v-model="from.create_time"
                placeholder="请输入问题时间"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="回复内容">
              <el-input
                v-model="from.reply_content"
                placeholder="请输入回复内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-button
        v-if="from.status == 0"
        type="primary"
        size="mini"
        @click="submit"
        >提交</el-button
      >
      <el-button
        v-if="from.status == 1"
        type="primary"
        size="mini"
        @click="submit"
        >修改</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
import { search_feedback, answer_question } from "../../api/ProblemFeedback";
export default {
  name: "ProblemFeedback",
  data() {
    return {
      problemData: [], //问题列表
      total: 0,
      param: {
        keywords: "",
        pageNum: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      dialogTitle: "问题回复",
      from: {},
      rules: {},
    };
  },
  created() {
    this.GetSearchProblem();
  },
  methods: {
    //获取问题数据
    GetSearchProblem() {
      search_feedback(this.param).then((res) => {
        this.problemData = res.data.list;
        this.total = res.data.total;
      });
    },
    //问题搜索
    GetSearchProblems() {
      this.param.pageNum = 1;
      this.param.pageSize = 10;
      search_feedback(this.param).then((res) => {
        this.problemData = res.data.list;
        this.total = res.data.total;
      });
    },
    InputValue(e) {
      if (e == "") {
        this.GetSearchProblems();
      }
    },
    //问题回复
    handleReply(item) {
      this.from = item;
      this.dialogTitle = "回复";
      this.dialogVisible = true;
    },
    // 提交表单
    submit() {
      if (!this.from.reply_content) {
        this.$message({
          message: "请回复反馈问题",
          type: "warning",
        });
        return;
      }
      // 请求
      console.log(this.from, 88);
      answer_question(this.from).then((res) => {
        console.log(res, 22);
        if (res.code == 200) {
          this.dialogTitle = "回复";
          this.dialogVisible = false;
          this.form = {};
          this.GetSearchProblem();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  color: #13ce66;
}
</style>
